module.exports = "<div class=story-line ng-if=slc.visible> <div typewrite text=slc.content type-delay=40 callback-fn=slc.showContinue() cursor=&shy;></div> <div ng-show=slc.canContinue class=continue ng-click=slc.onContinueClick()>Continue</div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./components/elements/storyLine/storyLine.html
// module id = 40
// module chunks = 0